import { createContext, useContext } from 'react';

interface PresentationScopeValue {
  /** Explicit null makes Base UI wait; an unresolved ref would fall back to document.body. */
  container: HTMLDivElement | null;
  boundary: HTMLDivElement | null;
}

export const PresentationContext = createContext<PresentationScopeValue | null>(null);

export function usePresentationScope() {
  return useContext(PresentationContext);
}
